export const UserType = {
    ACTIVE_DIRECTORY: 1,
    ONLINE_IDENTITY_SERVICE: 2,
}